export default __webpack_public_path__ + "1b2031896a702bc02b67544345d39302.riv";